import { AxiosInstance } from 'axios';
import { Authentication, AuthenticationResponse } from './loginTypes';

type AuthenticateByUsernameParams = Readonly<{
    username: string
}>

type ResetPasswordParams = Readonly<{
    email: string
}>

type AuthenticateByActivationCodeParams = Readonly<{
    type: string // Create enum for types
    value: string
}>

type CreatePasswordParams = Readonly<{
    oneTimeToken: string
    password: string
}>

type AuthenticateByPasswordParams = Readonly<{
    username: string
    password: string
    authentication: Authentication
}>

type ActivateAccountParams = Readonly<{
    username: string
    password: string
    authentication: Authentication
}>

export async function authenticateByUsername({ username }: AuthenticateByUsernameParams, axios: AxiosInstance): Promise<AuthenticationResponse> {
    const response = await axios.post("/authenticate/admin/username", {
        username
    })

    return response.data
}

export async function resetPassword({ email }: ResetPasswordParams, axios: AxiosInstance): Promise<AuthenticationResponse> {
    const response = await axios.post("/authenticate/resetPassword", {
        email
    })

    return response.data
}

export async function authenticateByActivationCode({ type, value }: AuthenticateByActivationCodeParams, axios: AxiosInstance): Promise<AuthenticationResponse> {
    const response = await axios.post("/authenticate/byType", {
        type, value
    })

    return response.data
}

export async function createPassword({ oneTimeToken, password }: CreatePasswordParams, axios: AxiosInstance): Promise<AuthenticationResponse> {
    const response = await axios.post("/authenticate/createPassword", {
        oneTimeToken, password
    })

    return response.data
}



export async function authenticateByPassword({ username, password, authentication }: AuthenticateByPasswordParams, axios: AxiosInstance): Promise<AuthenticationResponse> {


    const response = await axios.post("/authenticate", {
        username,
        password,
        authentication
    })

    return response.data
}

export async function activateAccount(request: ActivateAccountParams, axios: AxiosInstance): Promise<AuthenticationResponse> {
    const response = await axios.post("/authenticate/activateAdminAccount", request)
    return response.data
}
